module.exports = __webpack_public_path__ + "static/media/beach_chill.8a69f010.svg";